import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import { Layout } from '@/shared/layout';
import PrivateRoute from '@/shared/private-route';

// * Pages
import { HomePage } from './home-page';
import { AuthFactorPage } from './auth-factor';
import { AuthSellerPage } from './auth-seller';
import { SellerRequestsPage } from './OutgoingRequestsPage';
import { CreateSellerRequestPage } from './create-seller-request-page';
import { IncomingRequestsPage } from './IncomingRequestsPage';
import { SingleBuyerIncomingRequest } from './single-buyer-incoming-request-page';
import { SingleSellerRequestPage } from './single-seller-request-page';
import { FactorMainPage } from './factor-main-page';
import { FactorLimitsPage } from './factor-limits-page';
import { FactorSingleLimitPage } from './factor-single-limit-page';
import { FactorAvailableClientsPage } from './factor-available-clients-page';
import { FactorRequestsPage } from './factor-requests-page';
import { FactorLimitsAddClientPage } from './factor-limits-add-client-page';
import { SingleFactorRequestPage } from './single-factor-request-page';
import { FactorSettingsPage } from './factor-settings-page';
import TestPage from './test-page/test';

export const Routing = () => {
  return (
    <Router>
      <Routes>
        <Route path='/test' element={<TestPage />} />
        <Route path='/auth/seller' element={<AuthSellerPage />} />
        <Route path='/auth/factor' element={<AuthFactorPage />} />
        <Route path='/' element={<HomePage />} />
        <Route element={<Layout />}>
          <Route element={<PrivateRoute />}>
            <Route path='/seller'>
              <Route index element={<Navigate to='/seller/deals' replace />} />
              <Route path='/seller/deals' element={<SellerRequestsPage />} />
              <Route
                path='/seller/deals/create'
                element={<CreateSellerRequestPage />}
              />
              <Route
                path='/seller/deals/create/:id'
                element={<CreateSellerRequestPage />}
              />
              <Route
                path='/seller/deals/:id'
                element={<SingleSellerRequestPage />}
              />
            </Route>

            <Route path='/buyer'>
              <Route
                index
                element={<Navigate to='/buyer/incoming-requests' replace />}
              />
              <Route
                path='/buyer/incoming-requests'
                element={<IncomingRequestsPage />}
              />
              <Route
                path='/buyer/incoming-requests/:id'
                element={<SingleBuyerIncomingRequest />}
              />
              <Route
                path='/buyer/deals/create'
                element={<CreateSellerRequestPage type='buyer' />}
              />
              <Route
                path='/buyer/deals/create/:id'
                element={<CreateSellerRequestPage type='buyer' />}
              />
            </Route>

            <Route path='/factor'>
              <Route index element={<Navigate to='/factor/main' replace />} />
              <Route path='/factor/main' element={<FactorMainPage />} />
              <Route
                path='/factor/main/deals/:id'
                element={<SingleFactorRequestPage />}
              />

              <Route path='/factor/requests' element={<FactorRequestsPage />} />
              <Route
                path='/factor/requests/:id'
                element={<SingleFactorRequestPage />}
              />

              <Route path='/factor/limits' element={<FactorLimitsPage />} />
              <Route
                path='/factor/limits/:id'
                element={<FactorSingleLimitPage />}
              />
              <Route
                path='/factor/limits/clients'
                element={<FactorAvailableClientsPage />}
              />
              <Route
                path='/factor/limits/clients/add/:tin'
                element={<FactorLimitsAddClientPage />}
              />
              <Route path='/factor/settings' element={<FactorSettingsPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};
